/**
 * LuraCoin — moeda LURA.
 * Substitui 🪙 💰 em CoinBalance, Wallet, Store, badge `capitalista`.
 *
 * Variantes:
 *   - default: outline com "L" no centro.
 *   - solid:   preenchida (uso em hero da Loja, Coin Drop).
 */

import type { SVGProps } from "react";

interface LuraCoinProps extends SVGProps<SVGSVGElement> {
  variant?: "default" | "solid";
  strokeWidth?: number;
}

export function LuraCoin({
  width = 24,
  height = 24,
  strokeWidth = 1.75,
  variant = "default",
  ...rest
}: LuraCoinProps) {
  const isSolid = variant === "solid";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      role="img"
      aria-label="Moeda Livra"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <circle cx="12" cy="12" r="9" fill={isSolid ? "currentColor" : "none"} />
      <circle cx="12" cy="12" r="6.5" fill="none" strokeOpacity={isSolid ? 0.4 : 0.6} />
      {/* L de LURA */}
      <path
        d="M10.4 8.25v7.5h3.7"
        strokeWidth={strokeWidth + 0.4}
        stroke={isSolid ? "var(--color-background, #0e0e0e)" : "currentColor"}
      />
    </svg>
  );
}
